if (!process.env.DESTINATION) {
    require('dotenv').config();
}

import axios from 'axios';
import {isAuthorized} from './getEnvironment';
import {v4 as uuidV4} from 'uuid';

const URLDevelopment = () => 'http://cssresearch-dev/model/';
const EnvironmentDevelopment = () => process.env.DESTINATION === 'DEVELOPMENT';

export const fixURL = (append = '') => {

    if (EnvironmentDevelopment()) {
        return `${URLDevelopment()}api/${append}&t=${uuidV4()}`;
    } else {
        return `/model/api/${append}&t=${uuidV4()}`;
    }
};

export const fixPublicURL = (append = '') => {
    if (EnvironmentDevelopment()) {
        return `${URLDevelopment()}controllers/public/${append}&t=${uuidV4()}`;
    } else {
        return `/model/controllers/public/${append}&t=${uuidV4()}`;
    }
};

export const axiosFetch = () => {

    const headers = isAuthorized() ?
        {
            'Cache-Control': 'no-cache',
            'Authorization': 'f985d147-fc9f-49be-a3ef-6316397dc3a4'
        } : {
            'Cache-Control': 'no-cache',
        };

    return axios.create({
        baseURL: '',
        headers
    });
};

export const axiosForm = () => {

    const headers = {'Content-Type': 'multipart/form-data' };

    return axios.create({
        baseURL: '',
        headers
    });
};

export interface ApiResults {
    DATA: Array<any>;
    COLUMNS: Array<any>;
}